export const solicitationTypeActions = [
  { name: 'Prime', id: 'categoria_cliente_prime' },
  { name: 'Essencial', id: 'categoria_cliente_essencial' },
  { name: 'VoeBiz', id: 'categoria_cliente_voebiz' },
  { name: 'Super Prime', id: 'categoria_cliente_super_prime' },
  { name: 'Exclusive', id: 'categoria_cliente_exclusive' },
];

export const defaultValues = {
  attachments: [] as { fileName: string; contentType: string; data: string }[],
  solicitationType: '',
  subject: '',
  reservationCode: '',
  firstName: '',
  lastName: '',
  email: '',
  phoneNumber: '',
  clientCategory: '',
  message: '',
  relationshipWithGOL: '',
  travelAgent: '',
  voebizCode: '',
  category: '',
  subCategory: '',
};

export type NoLoggedValuesData = typeof defaultValues;
